import { Box, Grid, TextField, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../../constants/FieldsConst';
import { dateformat } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import SelectFieldTemasAcademicosComponent from '../../../../academico/temas_academicos/components/SelectFieldTemasAcademicos';
import { FechaField } from '../../../../accesos/components/FechaField';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { savePlanevaTemasAction } from '../PlanevaTemasAction';

const FormPlanevaTemas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const planevaTemasStore = Redux.useSelector((state) => state.planevaTemas);

  const activo = planevaTemasStore.activo;
  const fechaBloque = planEvaluacionStore.activo.fechaBloque;

  const initData = {
    desde: fechaBloque.desde,
    hasta: fechaBloque.hasta,
    desc: '',
    idTema: '',
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    desde: false,
    hasta: false,
    idTema: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idTema: Number(activo.tema.id),
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm() && _validDateRange()) {
      setLoadingSave(true);
      let res = await savePlanevaTemasAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idPlanEvaluacion: planEvaluacionStore.activo.id,
        },
        planEvaluacionStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  const _validDateRange = () => {
    const desde = new Date(data.desde);
    const hasta = new Date(data.hasta);
    if (hasta < desde) {
      setDataRequired({ ...dataError, hasta: true });
      notify('La fecha final no puede ser menor a la fecha de inicio', {
        warning: true,
      });
      return false;
    }
    return true;
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <LoadingWidget isLoading={loadingSave} isActivo={activo} />
        </Grid>

        <Grid item xs={12} md={12}>
          <SelectFieldTemasAcademicosComponent
            id="select-tema"
            value={data.idTema}
            isEmpty={false}
            required
            onChange={(idTema) => {
              _handleSetDataField(CONST.tema.idName, idTema);
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FechaField
            label={CONST.desde.label}
            value={data.desde}
            botonCurrentDate={false}
            error={dataError.desde}
            onChange={(e) => {
              const selectedDate = new Date(e);
              const fechaDesdeBloque = new Date(fechaBloque.desde);
              const fechaHastaBloque = new Date(fechaBloque.hasta);
              setDataRequired({ ...dataError, desde: false });
              if (selectedDate < fechaDesdeBloque) {
                notify(
                  'La fecha de inicio no puede ser menor a la fecha actual',
                  { error: true },
                );
                _handleSetDataField(CONST.desde.name, fechaBloque.desde);
                setDataRequired({ ...dataError, desde: true });
                return;
              }
              if (selectedDate > fechaHastaBloque) {
                notify(
                  'La fecha de inicio no puede ser mayor a la fecha tope del bloque',
                  { error: true },
                );
                _handleSetDataField(CONST.desde.name, fechaBloque.desde);
                setDataRequired({ ...dataError, desde: true });
                return;
              }
              _handleSetDataField(CONST.desde.name, dateformat(e, {}));
            }}
          />
          <Typography variant="caption" color="initial">
            Fecha de inicio del bloque:{' '}
            {dateformat(fechaBloque.desde, { standard: true })}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <FechaField
            label={CONST.hasta.label}
            value={data.hasta}
            botonCurrentDate={false}
            error={dataError.hasta}
            onChange={(e) => {
              const selectedDate = new Date(e);
              const fechaDesdeBloque = new Date(fechaBloque.desde);
              const fechaHastaBloque = new Date(fechaBloque.hasta);
              setDataRequired({ ...dataError, hasta: false });
              if (selectedDate < fechaDesdeBloque) {
                notify('La fecha final no puede ser menor a la fecha actual', {
                  error: true,
                });
                _handleSetDataField(CONST.hasta.name, fechaBloque.hasta);
                setDataRequired({ ...dataError, hasta: true });
                return;
              }
              if (selectedDate > fechaHastaBloque) {
                notify(
                  'La fecha final no puede ser mayor a la fecha tope del bloque',
                  { error: true },
                );
                _handleSetDataField(CONST.hasta.name, fechaBloque.hasta);
                setDataRequired({ ...dataError, hasta: true });
                return;
              }

              _handleSetDataField(CONST.hasta.name, dateformat(e, {}));
            }}
          />
          <Typography variant="caption" color="initial">
            Fecha tope del bloque:{' '}
            {dateformat(fechaBloque.hasta, { standard: true })}
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            autoComplete="off"
            multiline
            rows={2}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            save
            disabled={loadingSave}
            green
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormPlanevaTemas;
